import React from 'react'
import { Modal, Button } from '@byscott-io/corebyscott'
import Lex from '../Shared/Lex'

// Delegates to corebyscott's shared <Modal>, rendered inside `.cbs-scope` so
// core's Tailwind utilities apply during the Bootstrap→Tailwind migration (#635).
const ConfirmationModal = props => {
  const formButtons = () => {
    return (
      <div className="flex gap-3">
        <Button onClick={() => props.modalData?.closeClicked()} color="default"><Lex term="cancel" /></Button>
        <Button onClick={props.modalData?.confirmClicked} color="danger">Confirm Deletion</Button>
      </div>)
  }

  return (
    <div className="cbs-scope">
      <Modal
        open={props.modalData?.name === 'ConfirmationModal'}
        onClose={() => props.modalData?.closeClicked()}
        title={props.modalData?.header}
        size="md"
        footer={formButtons()}
      >
        {props.modalData?.children}
      </Modal>
    </div>
  )
}

export default ConfirmationModal
